module["exports"] = [
  "com.tr",
  "com",
  "biz",
  "info",
  "name",
  "gov.tr"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/internet/domain_suffix.js
// module id = 2773
// module chunks = 2